var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"home-container"},[_c('el-header',[_c('page-header')],1),_c('el-container',{staticStyle:{"height":"calc(100% - 60px)"}},[_c('el-aside',{style:({width: _vm.asideWidth + 'px'})},[_c('page-aside')],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }